import { useState, useEffect } from "react";

function useFetch() {
  const [weeklyRankingData, setWeeklyRankingData] = useState(null);
  const [totalRankingData, setTotalRankingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchRanking = async () => {
    try {
      const weeklyRankingResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/weeklyhighscore`
        
      );
      const weeklyRankingResult = await weeklyRankingResponse.json();
      setWeeklyRankingData(weeklyRankingResult);

      const totalRankingResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/highscore`
      );
      const totalRankingResult = await totalRankingResponse.json();
      setTotalRankingData(totalRankingResult);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRanking();
  }, []);

  return { weeklyRankingData, totalRankingData, loading, error };
}

export default useFetch;
